function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.1 14.75a1 1 0 0 1 .993.883l.007.117v2.85a2.903 2.903 0 0 1-2.73 2.895l-.17.005H2.9a2.903 2.903 0 0 1-2.895-2.73L0 18.6v-2.85a1 1 0 0 1 1.993-.117L2 15.75v2.85c0 .457.345.837.788.893l.112.007h13.3a.903.903 0 0 0 .893-.787l.007-.113v-2.85a1 1 0 0 1 1-1zM9.402.511l.073-.008L9.604.5l.12.014.138.035.111.044.098.052.104.074.082.073 3.8 3.8a1 1 0 0 1-1.32 1.497l-.094-.083-2.094-2.093.001 10.886a1 1 0 0 1-.883.993l-.117.007a1 1 0 0 1-.993-.883L8.55 14.8 8.549 3.914 6.457 6.007a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 3.8-3.8.112-.097.11-.071L9.18.57l.105-.035.118-.025z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.848381ba.svg";
export { ForwardRef as ReactComponent };